import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IAvailableTypes } from 'src/app/core/models/available-types.interface';
import { ISaleOrder, ISaleOrderRefund } from '../../../models/sale-order.interface';
import { SaleOrderService } from '../../../services/sale-order.service';

@Component({
    selector: 'eci-sale-order-refunds',
    templateUrl: './sale-order-refunds.component.html',
    styleUrls: ['./sale-order-refunds.component.scss'],
})
export class SaleOrderRefundsComponent implements OnChanges {

    @Input() info: ISaleOrder;
    @Input() availableTypes: IAvailableTypes;
    @Input() isB2BSaleOrder: boolean = false;
    @Input() isMarketplaceSO: boolean = false;

    creditOrders: ISaleOrder[] = [];
    showLoader = false;

    constructor(private saleOrderSvc: SaleOrderService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.info) {
            this.loadCreditOrders();
        }
    }

    private loadCreditOrders(): void {
        const refunds = this.info?.refunds;
        if (!refunds?.length) {
            this.creditOrders = [];
            return;
        }

        const fromApi = refunds
            .map((link: ISaleOrderRefund) => link.refundOrder)
            .filter((order): order is ISaleOrder => !!order);

        if (fromApi.length === refunds.length) {
            this.creditOrders = fromApi;
            return;
        }

        const refundIds = refunds
            .map((link: ISaleOrderRefund) => link.refundId)
            .filter((id): id is number => !!id);

        if (!refundIds.length) {
            this.creditOrders = [];
            return;
        }

        this.showLoader = true;
        forkJoin(
            refundIds.map((id) =>
                this.saleOrderSvc.getOrderById(id).pipe(catchError(() => of(null)))
            )
        ).subscribe((orders) => {
            this.creditOrders = orders.filter((order): order is ISaleOrder => !!order);
            this.showLoader = false;
        });
    }

    getRefundAmount(creditOrderId: number): number | null {
        const link = this.info?.refunds?.find((r) => r.refundId === creditOrderId);
        if (link?.refundAmount == null) {
            return null;
        }
        return Number(link.refundAmount);
    }
}
